import { Component, OnInit } from '@angular/core';
import {TpmService} from "src/app/dashboard/services/tpm.service";
import { NgIf } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-progress-spinner',
    templateUrl: './progress-spinner.component.html',
    styleUrls: ['./progress-spinner.component.scss'],
    imports: [NgIf, MatProgressSpinner]
})
export class ProgressSpinnerComponent implements OnInit {
  isLoading: boolean;
  constructor(private tpmService:TpmService) { }

  ngOnInit() {
    this.tpmService.isLoading.subscribe(value => {
      this.isLoading = value;
    })
  }

}
